import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import { StepBox } from '@/components/layout/step-box';
import { Flow } from '@/constants/flow';
import { useBizState } from '@/hooks/use-biz-state';

export const StepDisable: React.FC = () => {
  const { t } = useTranslation();
  const { userName, areaCode, authType } = useBizState();

  return (
    <StepBox
      backFlow={Flow.LOGIN_STEP_INPUT_USERNAME}
      account={authType === 'phone' ? `${areaCode} ${userName}` : userName}
      title={t('account_locked_title')}
    >
      <Stack spacing={2}>
        <Typography variant="body1">{t('account_locked_help_text')}</Typography>
      </Stack>
    </StepBox>
  );
};
